import { render, staticRenderFns } from "./SearchNoResults.vue?vue&type=template&id=3d118666&scoped=true&"
import script from "./SearchNoResults.vue?vue&type=script&lang=js&"
export * from "./SearchNoResults.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3d118666",
  null
  
)

export default component.exports